// ============================
// GA, Yahooリスティング関連
// ============================
export default function () {
  // Yahoo
  window.yjDataLayer = window.yjDataLayer || [];
  function ytag() { yjDataLayer.push(arguments); }
  ytag({"type":"ycl_cookie"});

  // 明示的にwindow.FDオブジェクトにリスティング用の関数を入れる
  window.FD = window.FD || {};

  // GA 電話クリック用定義
  window.FD.gtag_report_conversion = function(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    window.gtag('event', 'conversion', {
        'send_to': 'AW-921521785/DRdeCKm-xmgQ-Zy1twM',
        'event_callback': callback
    });
    return false;
  }

  // Yahoo 電話クリック用定義
  window.FD.yahoo_report_conversion = function(url) {
    var opt = {
      "yahoo_conversion_id": 1000995516,
      "yahoo_conversion_label": "tFp7CMmg44UBEIuMxYID",
      "yahoo_conversion_value": 0,
      "yahoo_remarketing_only": false,
      "onload_callback": function() {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      }
    };
    ytag({"type":"yss_call_conversion", "config": opt});
  }

  // 電話カウント
  window.FD.conversionTelButtonCountLabel = function(label) {
    window.gtag('event', 'call', {
      'event_category': 'label',
      'event_label': label,
    });
    window.FD.gtag_report_conversion(undefined);
    window.FD.yahoo_report_conversion(undefined);
  }

  // イベントトラッキング
  window.FD.conversionEventTracking = function(category, action, label) {
    window.gtag('event', action, {
      'event_category': category,
      'event_label': label,
    });
  }
}
